import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

function PrivateRoute({ children, allowedTypes = [] }) {
  const { userTipo } = useContext(AuthContext);

  // Verifica se está logado
  if (!userTipo) {
    // Não autenticado, redireciona para login
    return <Navigate to="/login" replace />;
  }

  // Verifica se tem permissão
  if (allowedTypes.length > 0 && !allowedTypes.includes(userTipo)) {
    // Sem permissão, redireciona para login ou página de erro (aqui login)
    return <Navigate to="/login" replace />;
  }

  // Tem permissão, renderiza o componente filho
  return children;
}

export default PrivateRoute;
